<section>
  @if (this.config().actionButton && this.config().actionButtonConfigs) {
  <button
    [style.cursor]="
      this.config().actionButtonConfigs?.form?.valid ? 'pointer' : 'not-allowed'
    "
    [style.background-color]="
      this.config().actionButtonConfigs?.form?.valid ? '#0000bf' : '#ebf5ff'
    "
    [disabled]="!this.config().actionButtonConfigs?.form?.valid"
    class="action"
  >
    {{ this.config().actionButtonConfigs?.text }}
  </button>
  } @if (this.config().cancelButton) {
  <button type="button" class="close" (click)="closeDialog()">
    {{ "common.cancel" | translate }}</button
  >}
</section>
